
window.Flickity.prototype._createResizeClass = function() {
    this.element.classList.add('flickity-resize');
};

var resize = window.Flickity.prototype.resize;
window.Flickity.prototype.resize = function() {
    this.element.classList.remove('flickity-resize');
    resize.call( this );
    this.element.classList.add('flickity-resize');
};

if (!customElements.get("lsg-announcement")) customElements.define("lsg-announcement", class LSGAnnouncement extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            slide: ".js-lsg-announcement-slider"
        };
        this.slider = this.querySelector(this.selectors.slide);
        this.init();
    }

    init() {
        this.flickity = new window.Flickity(this.slider, {
            wrapAround: true,
            pageDots: false,
            arrowShape: 'M7 1L2 6L7 11'
        });
        this.flickity._createResizeClass();
    }
});
